import { datadogRum } from "@datadog/browser-rum";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { storage } from "@/modules/storage";
import { useAppState } from "contexts/AppContext";
import { Analytics } from "modules/analytics";
import { type LauncherKey, resetAppIcon } from "modules/appIcon/helpers/appIcon.helpers";
import { ThemeContext } from "pages/Root";
import Services from "services/Services";
import { clearAcknowledgedPopupPromotionIds } from "utils/functions";
import { isNativeMobileApp } from "utils/platform.helpers";

interface UseLogoutProps {
  subdomain?: string | null;
}

export const useLogout = ({ subdomain }: UseLogoutProps = {}) => {
  const navigate = useNavigate();
  const appState = useAppState();
  const { resetTheme } = useContext(ThemeContext);

  return async () => {
    // Delete the remembered Customer.io device before clearing analytics identity.
    await Analytics.reset();

    appState.clear();

    clearAcknowledgedPopupPromotionIds();
    await Services.auth.clearAll();
    datadogRum.clearUser();

    // Clear all persisted storage (in-memory cache + Capacitor Preferences)
    // so no onboarding state, referral codes, or profile data leaks to the
    // next user session. storage.clear() calls Preferences.clear() internally.
    await storage.clear();

    if (isNativeMobileApp()) {
      const disable = subdomain ? [`launcher_${subdomain}`] : [];

      await resetAppIcon(disable as LauncherKey[]);

      resetTheme();
    }

    navigate("/signin");
  };
};
